import React, { Component, PropTypes } from 'react';
import Dropzone from 'react-dropzone';
import ImageGallery from 'react-image-gallery';

class ImageUploadWidget extends Component {
    onDrop() {}

    render() {
        let dropzoneRef;
        return (
            <div id={this.props.id}>
                <div>
                    <div style={{ display: 'none' }}>
                        <Dropzone
                            ref={node => {
                                dropzoneRef = node;
                            }}
                            onDrop={this.props.onDrop}
                        >
                            {/* <div>
                  {this.props.image ? <img className="image-upload-container" src={this.props.image.preview}/> : <img className="image-holder" src="/public/images/image_holder.png" /> }
                  </div> */}
                        </Dropzone>
                    </div>
                    <div>
                        <button
                            style={{ top: '29px' }}
                            className="spark-btn spark-btn--sm align-middle"
                            type="button"
                            onClick={() => {
                                dropzoneRef.open();
                            }}
                        >
                            UPLOAD
                        </button>
                    </div>
                    {/* <div className="col-sm-6">
          <div className="normal-text">Click on the image to the left to upload a new image, or drag and drop on it</div>
        </div>
        <div className="col-md-6">
          <ImageGallery items={this.props.items} slideInterval={2000}
                        showPlayButton={false} showBullets={true}/>
        </div> */}
                </div>
            </div>
        );
    }
}

ImageUploadWidget.propTypes = {
    title: PropTypes.string,
    onDrop: PropTypes.func,
    image: PropTypes.object
};

export default ImageUploadWidget;



// WEBPACK FOOTER //
// ./src/components/pages/theme/images/ImageUploadWidget.js